export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.dev)
    return

  const { signatureHost } = useRuntimeConfig().public
  const { host } = useRequestURL({ xForwardedHost: true })

  if (signatureHost && host === signatureHost && to.path !== '/')
    throw404()
})
